import styled from 'styled-components';

const DetailPageTitle = styled.h3`
  font-size: 48px;
  margin-bottom: 8px;
  word-wrap: break-word;
`;

export default DetailPageTitle;
